import { useNavigate } from "react-router-dom";
import Form from "./form";

interface Props {
    redirectUrl?: string;
}

export default function Login({ redirectUrl = "/app/dashboard" }: Props) {
    const navigate = useNavigate();

    return <Form onSuccess={(url) => navigate(url || redirectUrl)} />;
}
